// // Navbar Component
// "use client";

// import { useState, useRef, useEffect } from "react";
// import Image from "next/image";
// import Link from "next/link";
// import { cn } from "../lib/utils";
// import Button from "./button";
// import { usePathname } from "next/navigation";
// import { LuChevronDown } from "react-icons/lu";
// import {
//   servicesLinks,
//   navLinks,
//   industriesLinks,
//   aiLinks,
//   opportunitiesLinks,
// } from "@/lib/navLinks";
// import ButtonNew from "./buttonNew";
// import { useRouter } from "next/router";

// function Navbar({ setActiveSection }) {
//   const lastScrollY = useRef(0);
//   const [isNavbarOpen, setIsNavbarOpen] = useState(false);
//   const [isClickedServices, setIsClickedServices] = useState(false);
//   const [isClickedOpportunities, setIsClickedOpportunities] = useState(false);
//   const [isClickedIndustries, setIsClickedIndustries] = useState(false);
//   const [isHoverIndustries, setIsHoverIndustries] = useState(false);
//   const [isHoverWork, setIsHoverWork] = useState(false);

//   const [isNavbarVisible, setIsNavbarVisible] = useState(true);
//   const [hideLogo, setHideLogo] = useState(true);
//   const pathname = usePathname();
//   const isAIPage = pathname === "/ai";

//   const handleScroll = () => {
//     setHideLogo(pathname === "/" && window.scrollY < window.innerHeight);
//     if (window.scrollY > lastScrollY.current) {
//       setIsNavbarVisible(false);
//     } else {
//       setIsNavbarVisible(true);
//     }
//     lastScrollY.current = window.scrollY;
//   };

//   useEffect(() => {
//     handleScroll();
//     lastScrollY.current = window.scrollY;
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [pathname]);

//   useEffect(() => {
//     if (isNavbarOpen) {
//       document.documentElement.style.overflow = "hidden";
//     } else {
//       document.documentElement.style.overflow = "auto";
//     }
//   }, [isNavbarOpen]);

//   return (
//     <nav
//       className={cn(
//         "fixed bg-palette-neutral-4 text-palette-neutral-1 w-full z-40",
//         "transition-transform duration-1000 ease-[cubic-bezier(0.22,0.61,0.36,1)] delay-200",
//         isNavbarVisible ? "translate-y-0" : "-translate-y-full",
//       )}>
//       <div
//         className={cn(
//           "flex px-4 sm:px-10 md:px-20 py-4 md:py-6 items-center",
//           "transition-all duration-300 ease-in-out pb-3",
//         )}>
//  <Link passHref href="/" className="flex items-center hover:scale-105 transition-all duration-500 ease-in-out active:scale-95">
//       <Image
//         className="transition-opacity duration-500 max-w-20 md:max-w-28"
//         src="/assets/logo/asynq_logo_transparent.png"
//         alt="Asynq Logo"
//         width={1000}
//         height={1000}
//       />
//     </Link>
//         {!isAIPage && (
//           <>
//             <ul className="hidden xl:flex xl:items-center xl:gap-10 ml-10">
//             <li>
//                 <button onClick={() => setActiveSection("exploreTalent")}>
//                   <span>Our Developers</span>
//                 </button>
//               </li>
//               <li>
//                 <button onClick={() => setActiveSection("whyUs")}>
//                   <span>Why Us?</span>
//                 </button>
//               </li>
//               <li>
//                 <button onClick={() => setActiveSection("projectApproach")}>
//                   <span>Hiring Process</span>
//                 </button>
//               </li>
//               <li
//                 className="relative pb-1"
//                 onMouseEnter={() => setIsHoverWork(true)}
//                 onMouseLeave={() => setIsHoverWork(false)}>
//                 <button className="relative loading-link text-base flex items-center cursor-pointer mt-2">
//                   <span className="self-end">About Us</span>
//                   <LuChevronDown className="inline-block ml-2 w-4" />
//                 </button>
//                 <div
//                   className={cn(
//                     "transition-all duration-100 ease-in-out absolute top-8 flex flex-col gap-4 z-50 bg-palette-neutral-4 w-56 px-6 py-6 rounded border border-palette-neutral-1",
//                     isHoverWork ? "" : "hidden",
//                   )}>
//                   {navLinks.map((link) => (
//                     <Link
//                       key={link.text}
//                       href={link.link}
//                       className="loading-link text-base">
//                       {link.text}
//                     </Link>
//                   ))}
//                 </div>
//               </li>
//               <li className="relative pb-1">
//                 <Link
//                   className="loading-link text-base inline-block mt-2"
//                   href={"/blog"}>
//                   Blog
//                 </Link>
//               </li>
//             </ul>
//             <div className="ml-auto flex items-center space-x-1">
//               <div className="hidden xl:block">
//                 <Button
//                   className="w-fit px-4 md:px-6 py-1 text-sm md:text-base"
//                   text="Apply as a developer"
//                   isLink={true}
//                   link="/opportunities/developer"
//                 />
//               </div>
//               <div className="hidden xl:block">
//                 <ButtonNew
//                   className="border border-palette-neutral-1 bg-[rgb(20 190 190 / var(--tw-bg-opacity))] px-4 md:px-3 py-2 text-sm md:text-base ml-4"
//                   text="Hire Top Talent"
//                   isLink={true}
//                   link="/opportunities/client"
//                 />
//               </div>
//             </div>
//           </>
//         )}
//         <div className="block xl:hidden ml-auto">
//           <button
//             className="hover:scale-110 active:scale-95 transition-all duration-300 ease-in-out outline-none"
//             onClick={() => setIsNavbarOpen(!isNavbarOpen)}>
//             <p
//               className={cn(
//                 "w-6 sm:w-8 rounded h-1 bg-palette-neutral-1 transition-all duration-300 ease-in-out",
//                 !isNavbarOpen ? "" : "rotate-45 origin-center",
//               )}></p>
//             <p
//               className={cn(
//                 "transition-all duration-300 ease-in-out rounded h-1 bg-palette-neutral-1",
//                 !isNavbarOpen
//                   ? "w-3 md:w-4 mt-1 ml-auto"
//                   : "w-6 md:w-8 -rotate-45 origin-center -translate-y-1",
//               )}></p>
//           </button>
//         </div>
//       </div>

//       {/* mobile nav */}
//       <ul
//         className="fixed flex flex-col items-center text-white z-50 bg-black w-full h-screen px-4 sm:px-10 md:px-20 pt-4 md:pt-8 gap-y-5 xl:hidden"
//         style={{
//           transform: isNavbarOpen ? "translateX(0)" : "translateX(100%)",
//           transition: "transform 0.2s ease-in-out",
//         }}>
//         {navLinks.map((link) => (
//           <li key={link.text} className="relative pb-1">
//             <Link
//               className="loading-link text-base inline-block"
//               href={link.link}>
//               {link.text}
//             </Link>
//           </li>
//         ))}

//         <li
//           className="relative pb-1 flex flex-col items-center"
//           onClick={() => {
//             setIsClickedServices(!isClickedServices);
//           }}>
//           <button className="relative loading-link text-base flex items-center cursor-pointer">
//             <span className="self-end">Services</span>
//             <LuChevronDown className="inline-block ml-2 font-semibold w-4" />
//           </button>
//           <div
//             className={cn(
//               "flex flex-col items-center gap-4 z-50 bg-palette-neutral-4 w-56 px-6 py-6 rounded",
//               !isClickedServices && "hidden",
//             )}>
//             {servicesLinks.map((link) => (
//               <Link
//                 key={link.text}
//                 href={link.link}
//                 className="loading-link text-base">
//                 {link.text}
//               </Link>
//             ))}
//           </div>
//         </li>

//         <li
//           className="relative pb-1 flex flex-col items-center"
//           onClick={() => {
//             setIsClickedServices(false);
//             setIsClickedIndustries(!isClickedIndustries);
//           }}>
//           <button className="relative loading-link text-base flex items-center cursor-pointer">
//             <span className="self-end">Industries</span>
//             <LuChevronDown className="inline-block ml-2 font-semibold w-4" />
//           </button>
//           <div
//             className={cn(
//               "flex flex-col items-center gap-4 z-50 bg-palette-neutral-4 w-56 px-6 py-6 rounded",
//               !isClickedIndustries && "hidden",
//             )}>
//             {industriesLinks.map((link) => (
//               <Link
//                 key={link.text}
//                 href={link.link}
//                 className="loading-link text-base">
//                 {link.text}
//               </Link>
//             ))}
//           </div>
//         </li>

//         <li
//           className="relative pb-1 flex flex-col items-center"
//           onClick={() => {
//             setIsClickedIndustries(false);
//             setIsClickedOpportunities(!isClickedOpportunities);
//           }}>
//           <button className="relative loading-link text-base flex items-center cursor-pointer">
//             <span className="self-end">Opportunities</span>
//             <LuChevronDown className="inline-block ml-2 font-semibold w-4" />
//           </button>
//           <div
//             className={cn(
//               "flex flex-col items-center gap-4 z-50 bg-palette-neutral-4 w-56 px-6 py-6 rounded",
//               !isClickedOpportunities && "hidden",
//             )}>
//             {opportunitiesLinks.map((link) => (
//               <Link
//                 key={link.text}
//                 href={link.link}
//                 className="loading-link text-base">
//                 {link.text}
//               </Link>
//             ))}
//           </div>
//         </li>

//         <li className="relative pb-1 flex flex-col items-center">
//           <Link
//             className="loading-link text-base inline-block"
//             href={"/blog"}
//             onClick={() => setIsNavbarOpen(false)}>
//             Blog
//           </Link>
//         </li>

//         <li className="mt-5">
//           <Button
//             className="w-full md:w-fit px-4 md:px-6 py-1 text-sm md:text-base"
//             text="Apply as a developer"
//             isLink={true}
//             link="/opportunities/developer"
//           />
//         </li>
//         <li>
//           <ButtonNew
//             className="border border-palette-neutral-1 bg-[rgb(20 190 190 / var(--tw-bg-opacity))] px-4 md:px-3 py-2 text-sm md:text-base ml-4"
//             text="Hire Top Talent"
//             isLink={true}
//             link="/opportunities/client"
//           />
//         </li>
//       </ul>
//     </nav>
//   );
// }

// export default Navbar;

// Navbar Component
"use client";

import { useState, useRef, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { cn } from "../lib/utils";
import Button from "./button";
import { usePathname } from "next/navigation";
import { LuChevronDown } from "react-icons/lu";
import {
  servicesLinks,
  navLinks,
  industriesLinks,
  aiLinks,
  opportunitiesLinks,
} from "@/lib/navLinks";
import ButtonNew from "./buttonNew";
import { useRouter } from "next/router";

function Navbar({ setActiveSection }) {
  const lastScrollY = useRef(0);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isClickedServices, setIsClickedServices] = useState(false);
  const [isClickedOpportunities, setIsClickedOpportunities] = useState(false);
  const [isClickedIndustries, setIsClickedIndustries] = useState(false);
  const [isHoverIndustries, setIsHoverIndustries] = useState(false);
  const [isHoverWork, setIsHoverWork] = useState(false);

  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [hideLogo, setHideLogo] = useState(true);
  const pathname = usePathname();
  const isAIPage = pathname === "/ai";

  const handleScroll = () => {
    setHideLogo(pathname === "/" && window.scrollY < window.innerHeight);
    if (window.scrollY > lastScrollY.current) {
      setIsNavbarVisible(false);
    } else {
      setIsNavbarVisible(true);
    }
    lastScrollY.current = window.scrollY;
  };

  useEffect(() => {
    handleScroll();
    lastScrollY.current = window.scrollY;
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (isNavbarOpen) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
    }
  }, [isNavbarOpen]);

  return (
    <nav
      className={cn(
        "fixed bg-palette-neutral-4 text-palette-neutral-1 w-full z-40",
        "transition-transform duration-1000 ease-[cubic-bezier(0.22,0.61,0.36,1)] delay-200",
        isNavbarVisible ? "translate-y-0" : "-translate-y-full",
      )}>
      <div
        className={cn(
          "flex px-4 sm:px-10 md:px-20 py-4 md:py-6 items-center",
          "transition-all duration-300 ease-in-out pb-3",
        )}>
        <Link
          passHref
          href="/"
          className="flex items-center hover:scale-105 transition-all duration-500 ease-in-out active:scale-95">
          <Image
            className="transition-opacity duration-500 max-w-20 md:max-w-28"
            src="/assets/logo/asynq_logo_transparent.png"
            alt="Asynq Logo"
            width={1000}
            height={1000}
          />
        </Link>
        {!isAIPage && (
          <>
            <ul className="hidden xl:flex xl:items-center xl:gap-10 ml-10">
              <li>
                <Link href="/#exploreTalent" scroll={false}>
                  <button>Our Developers</button>
                </Link>
              </li>
              <li>
                <Link href="/#whyUs" scroll={false}>
                  <button>Why Us?</button>
                </Link>
              </li>
              <li>
                <Link href="/#projectApproach" scroll={false}>
                  <button>Hiring Process</button>
                </Link>
              </li>
              <li
                className="relative pb-1"
                onMouseEnter={() => setIsHoverWork(true)}
                onMouseLeave={() => setIsHoverWork(false)}>
                <button className="relative loading-link text-base flex items-center cursor-pointer mt-2">
                  <span className="self-end">About Us</span>
                  <LuChevronDown className="inline-block ml-2 w-4" />
                </button>
                <div
                  className={cn(
                    "transition-all duration-100 ease-in-out absolute top-8 flex flex-col gap-4 z-50 bg-palette-neutral-4 w-56 px-6 py-6 rounded border border-palette-neutral-1",
                    isHoverWork ? "" : "hidden",
                  )}>
                  {navLinks.map((link) => (
                    <Link
                      key={link.text}
                      href={link.link}
                      className="loading-link text-base">
                      {link.text}
                    </Link>
                  ))}
                </div>
              </li>
              <li className="relative pb-1">
                <Link
                  className="loading-link text-base inline-block mt-2"
                  href={"/blog"}>
                  Blog
                </Link>
              </li>
            </ul>
            <div className="ml-auto flex items-center space-x-1">
              <div className="hidden xl:block">
                <Button
                  className="w-fit px-4 md:px-6 py-1 text-sm md:text-base"
                  text="Apply as a developer"
                  isLink={true}
                  link="/opportunities/developer"
                />
              </div>
              <div className="hidden xl:block">
                <ButtonNew
                  className="border border-palette-neutral-1 bg-[rgb(20 190 190 / var(--tw-bg-opacity))] px-4 md:px-3 py-2 text-sm md:text-base ml-4"
                  text="Hire Top Talent"
                  isLink={true}
                  link="/opportunities/client"
                />
              </div>
            </div>
          </>
        )}
        <div className="block xl:hidden ml-auto">
          <button
            className="hover:scale-110 active:scale-95 transition-all duration-300 ease-in-out outline-none"
            onClick={() => setIsNavbarOpen(!isNavbarOpen)}>
            <p
              className={cn(
                "w-6 sm:w-8 rounded h-1 bg-palette-neutral-1 transition-all duration-300 ease-in-out",
                !isNavbarOpen ? "" : "rotate-45 origin-center",
              )}></p>
            <p
              className={cn(
                "transition-all duration-300 ease-in-out rounded h-1 bg-palette-neutral-1",
                !isNavbarOpen
                  ? "w-3 md:w-4 mt-1 ml-auto"
                  : "w-6 md:w-8 -rotate-45 origin-center -translate-y-1",
              )}></p>
          </button>
        </div>
      </div>

      {/* mobile nav */}
      <ul
        className="fixed flex flex-col items-center text-white z-50 bg-black w-full h-screen px-4 sm:px-10 md:px-20 pt-4 md:pt-8 gap-y-5 xl:hidden"
        style={{
          transform: isNavbarOpen ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.2s ease-in-out",
        }}>
      
        <li className="relative pb-1 flex flex-col items-center">
          <Link href="/#exploreTalent" scroll={false}  onClick={() => setIsNavbarOpen(false)} >
            <button>Our Developers</button>
          </Link>
        </li>

        <li className="relative pb-1 flex flex-col items-center">
          <Link href="/#whyUs" scroll={false}  onClick={() => setIsNavbarOpen(false)}> 
            <button>Why Us?</button>
          </Link>
        </li>

        <li className="relative pb-1 flex flex-col items-center">
          <Link href="/#projectApproach" scroll={false}  onClick={() => setIsNavbarOpen(false)} >
            <button>Hiring Process</button>
          </Link>
        </li>
        <li
          className="relative pb-1 flex flex-col items-center"
          onClick={() => {
            setIsClickedIndustries(false);
            setIsClickedOpportunities(!isClickedOpportunities);
          }}>
          <button className="relative loading-link text-base flex items-center cursor-pointer">
            <span className="self-end">About Us</span>
            <LuChevronDown className="inline-block ml-2 font-semibold w-4" />
          </button>
          <div
            className={cn(
              "flex flex-col items-center gap-4 z-50 bg-palette-neutral-4 w-56 px-6 py-6 rounded",
              !isClickedOpportunities && "hidden",
            )}>
            {navLinks.map((link) => (
              <Link
                key={link.text}
                href={link.link}
                className="loading-link text-base">
                {link.text}
              </Link>
            ))}
          </div>
        </li>

        <li className="relative pb-1 flex flex-col items-center">
          <Link
            className="loading-link text-base inline-block"
            href={"/blog"}
            onClick={() => setIsNavbarOpen(false)}>
            Blog
          </Link>
        </li>

        <li className="mt-5">
          <Button
            className="w-full md:w-fit px-4 md:px-6 py-1 text-sm md:text-base"
            text="Apply as a developer"
            isLink={true}
            link="/opportunities/developer"
          />
        </li>
        <li>
          <ButtonNew
            className="border border-palette-neutral-1 bg-[rgb(20 190 190 / var(--tw-bg-opacity))] px-4 md:px-3 py-2 text-sm md:text-base ml-4"
            text="Hire Top Talent"
            isLink={true}
            link="/opportunities/client"
          />
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
